export const basketConstants = {
    ADD_TO_BASKET: 'ADD_TO_BASKET',
    CLEAR_BASKET: 'CLEAR_BASKET',
};
